module.exports = __webpack_public_path__ + "media/images/help/image1-ca41735ca9803e6502641685bbd5ee36.jpeg";